import React from "react";
import { Schema } from "@comparaonline/products-schema";

import { StartStep } from "./StartStep";
import { FormStep } from "./FormStep";
import { FinishStep } from "./FinishStep";
import { ReviewFormStep } from "./types";

interface FormStepsProps {
  step: ReviewFormStep;
  changeStep: (step: ReviewFormStep) => void;
  product: Schema.ProductListProduct;
}

export const FormSteps: React.FC<FormStepsProps> = ({ product, step, changeStep }) => {
  switch (step) {
    default:
    case ReviewFormStep.Start:
      return <StartStep onContinue={() => changeStep(ReviewFormStep.Form)} />;
    case ReviewFormStep.Form:
      return (
        <FormStep
          product={product}
          onCancel={() => changeStep(ReviewFormStep.Start)}
          onSubmit={() => changeStep(ReviewFormStep.Finish)}
        />
      );
    case ReviewFormStep.Finish:
      return <FinishStep />;
  }
};
